// Relative Imports
import {
  Container,
  Window,
  Row,
  Button,
  Column,
  Body,
  Image,
  Data,
  Header,
  Grid,
  Buttons,
} from "./styles";
import TextArea from "../../_forms/text-area/index.js";
import { Title, H5, P } from "../../../constants/type.js";
import Radio from "../../_forms/radio/index.js";

const Modal = ({ onClick }) => {
  return (
    <Container>
      <Window>
        <Body>
          <Row>
            <Image />
            <Data>
              <div>
                <Header>
                  <Title
                    color={"primary"}
                    fontWeight={"bold"}
                    fontSize="32px"
                    textTransform="uppercase"
                  >
                    Accept User
                  </Title>
                  <P>Registered: 11:11am Dec 13th 2022 </P>
                </Header>

                <Column>
                  <P>
                    Please explain why you're allowing this user into the
                    community
                  </P>
                  <TextArea
                    rows="10"
                    placeholder="Why are you allowing this member into the community"
                  />
                </Column>
                <Radio />
              </div>
              <Buttons>
                <Button onClick={onClick}>No</Button>
                <Button onClick={onClick}>Yes</Button>
              </Buttons>
            </Data>
          </Row>
        </Body>
      </Window>
    </Container>
  );
};

export default Modal;
